"use client";

import { Button } from "../../ui/button";
import type { ModelsCategory } from "../../../types/strapi/models";

interface NewsListCategoryLinkProps {
  category: ModelsCategory;
  sectionName: string;
  anchor?: boolean;
}

function NewsListCategoryLink({
  category,
  sectionName,
  anchor = false,
}: NewsListCategoryLinkProps) {
  const { slug, name, path } = category;
  const href = anchor ? `#${slug}` : path;

  return (
    <Button
      appearance="solid"
      color="blueLight"
      href={href}
      sectionName={`${sectionName}_${name}`}
      size="xxs"
      title={name}
    >
      {name}
    </Button>
  );
}

export default NewsListCategoryLink;
